import React, {useState} from "react";
import {Modal, Tabs, Typography} from "antd";
import ReactFlow, {Background, ReactFlowProvider} from 'react-flow-renderer';
import {Area, AreaChart, CartesianGrid, Tooltip as ChartTooltip, XAxis, YAxis} from "recharts";
import {ChartFrame, ChartHint} from "../ui/ChartFrame";
import {chartPalette, gridProps, numberFormat, tokens, valueAxisProps, yearAxisProps} from "../ui/tokens";
import {fitFlowView} from "./FlowDiagram";

export const DrawStages = ({stage, item}) => {
    const data = item.data.map((val, i) => ({year: 2011 + i, val}))

    const last = data[data.length - 1]

    return <ChartFrame title={"Динамика по годам"} hint={"Пациенты, человек"}
                       summary={last ? `${last.year}: ${numberFormat.format(Math.round(last.val))}` : null}
                       aspect={2.4} minHeight={220}>
        <AreaChart data={data} margin={{top: 4, right: 8, left: 0, bottom: 0}}>
            <defs>
                <linearGradient id={`nodeGradient-${item.value}`} x1="0" y1="0" x2="0" y2="1">
                    <stop offset="0%" stopColor={chartPalette[0]} stopOpacity={0.3}/>
                    <stop offset="100%" stopColor={chartPalette[0]} stopOpacity={0}/>
                </linearGradient>
            </defs>
            <CartesianGrid {...gridProps}/>
            <XAxis dataKey="year" {...yearAxisProps}/>
            <YAxis {...valueAxisProps}/>
            <ChartTooltip content={<ChartHint unit={"чел."}/>} cursor={{stroke: tokens.border}}/>
            <Area isAnimationActive={false} type={"monotone"} dataKey={"val"} name={item.title}
                  stroke={chartPalette[0]} strokeWidth={2} fill={`url(#nodeGradient-${item.value})`}/>
        </AreaChart>
    </ChartFrame>
}

const InitElementsOfNode = (node, model, setCurr) => {
    console.log('n', node, model, setCurr)

    const incomeEdge = model.stepConnection.filter(itemSelector => itemSelector.target == node.value).map(item => ({
        ...item,
        id: "e" + item.source + '-' + item.target,
        animated: true,
    })).map(item => ({...item, label: item.hideLabel ? '' : (item?.sender?.value ? Math.round(item?.sender?.value * 100) + '%' : item.label)}))
    const outcomeEdge = model.stepConnection.filter(itemSelector => itemSelector.source == node.value).map(item => ({
        ...item,
        id: "e" + item.source + '-' + item.target,
        animated: true,
    })).map(item => ({...item, label: item.hideLabel ? '' : (item?.sender?.value ? Math.round(item?.sender?.value * 100) + '%' : item.label)}))
    const incomeNode = model.stepOption.filter(itemSelector => incomeEdge.filter(edge => itemSelector.value == edge.source).length > 0).map((itemQ, i, arr) => ({
        id: itemQ.value,
        type: itemQ.type,
        data: {label: <div onClick={() => setCurr(itemQ)}>{itemQ.title}</div>},
        isNode: true,
        position: {
            x: ((600 * (i + 0.5)) / arr.length )  , y: 50}}))
    const outcomeNode = model.stepOption.filter(itemSelector => outcomeEdge.filter(edge => itemSelector.value == edge.target).length > 0).map((itemQ, i, arr) => ({
        id: itemQ.value,
        type: itemQ.type,
        data: {label: <div onClick={() => setCurr(itemQ)}>{itemQ.title}</div>},
        isNode: true,
        position: {
            x: ((600 * (i + 0.5)) / arr.length ) , y: 300}}))

    const initialElements = [ {
        id: node.value,
        value: node.value,
        type: '',
        data: {
            label: (
                <>
                    {node.title}
                </>
            ),
        },
        position: { x: 300, y: 200 },
    },...outcomeNode,...incomeNode, ...incomeEdge,...outcomeEdge,
        ...incomeNode.map(item => ({...item, id: item.id + 'pre', position: {x: item.position.x, y: -50}, data: {label: <></>}})),
        ...incomeNode.map(item => ({id: item.id + 'pre2', source: item.id + 'pre', target: item.id, animated: true})),
        ...outcomeNode.map(item => ({...item, id: item.id + 'pre', position: {x: item.position.x, y: 550}, data: {label: <></>}})),
        ...outcomeNode.map(item => ({id: item.id + 'pre2', source: item.id + 'pre', target: item.id, animated: true})),
    ]


    console.log('el', initialElements)

    return initialElements
}



export const NodeModal = ({item, model}) => {
    const [visible, setVisible] = useState()
    const [curr, setCurr] = useState(item)

    const initialElements = InitElementsOfNode(curr, model, setCurr)

    item.typex = item.typex || item.type
    const hide = () => setVisible(false)

    const hasChart = Boolean(item.data) && (item.typex === 'stage' || item.drawData)
    const defaultTab = hasChart || item.description ? 'data' : (item.cr ? 'cr' : 'links')

    return <>
        <div className={"flow-node"} role={"button"} tabIndex={0}
             onClick={() => {
                 setCurr(item)
                 setVisible(true)
             }}
             onKeyDown={(e) => {
                 if (e.key === 'Enter' || e.key === ' ') {
                     setCurr(item)
                     setVisible(true)
                 }
             }}>{item.title}</div>

        <Modal width={960} style={{top: 12, maxWidth: '100vw'}} bodyStyle={{padding: 16}}
               visible={visible} onOk={hide} onCancel={hide} footer={null} title={item.title}>
            <Tabs defaultActiveKey={defaultTab} destroyInactiveTabPane>
                {(hasChart || item.description) &&
                    <Tabs.TabPane tab={"Данные"} key={"data"}>
                        {item.description &&
                            <Typography.Paragraph style={{marginBottom: hasChart ? 16 : 0}}>
                                {item.description}
                            </Typography.Paragraph>}
                        {hasChart && <DrawStages stage={item.value} item={item}/>}
                    </Tabs.TabPane>}

                {item.cr &&
                    <Tabs.TabPane tab={"Клинические рекомендации"} key={"cr"}>
                        <iframe title={"Клинические рекомендации"} src={item.cr}
                                style={{width: '100%', height: '70vh', border: 0}}/>
                    </Tabs.TabPane>}

                <Tabs.TabPane tab={"Связи элемента"} key={"links"}>
                    <ReactFlowProvider>
                        <div style={{height: '60vh'}}>
                            <ReactFlow
                                elements={initialElements}
                                snapToGrid={true}
                                snapGrid={[15, 15]}
                                onLoad={fitFlowView}
                                style={{height: "100%"}}
                                key={JSON.stringify(initialElements?.map(el => el.id))}
                                nodesDraggable={false}
                                panOnDrag={true}
                            >
                                <Background color="#cbd5e1" gap={16}/>
                            </ReactFlow>
                        </div>
                    </ReactFlowProvider>
                </Tabs.TabPane>
            </Tabs>
        </Modal>
    </>
}





export default NodeModal
